var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-bottom"},[_c('span',{staticClass:"copyright"},[_vm._v("深圳市慧智创新网络有限公司 版权所有")]),_c('span',{staticClass:"ui-link"})])
}]

export { render, staticRenderFns }